
import Component from 'vue-class-component';

// The base for every interactive modal
import InteractiveModalBase from './internals/InteractiveBase.vue';

// Modal types
import { ModalType, InteractiveModalOptions } from './types';

/**
 *  Used to alert the user using a modal.
 */
@Component
export default class AlertModal extends InteractiveModalBase {

    protected type = ModalType.Error;

    /**
     *  The default options for the alert modal.
     */
    protected options: InteractiveModalOptions = {
        body: '',
        confirm: {
            title: 'Sluiten',
            content: 'Sluiten',
        },
    };

}
